import { SiteUrls } from '@tableau/shared-urls';
import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { classes } from 'typestyle/lib';

import { Formatters, Messages } from '../../codegen/Localize';
import { CellWithCountAndToolTip } from '../../commonInfra/components/dataGrid/CellWithCount';
import { cssClass, flexColumnStyle, textEllipsis } from '../../style';
import { FlowBaseInfo } from '../models/FlowInfo';

const cssPrefix = 'FlowLinksWithIcon';

const flowIconClass = 'tb-link-flow';

export const displayedLinkClass = cssClass(cssPrefix, 'displayedLink', textEllipsis, {
  display: 'inline-block',
  verticalAlign: 'top',
  maxWidth: 150,
});

const textClass = cssClass(cssPrefix, 'text', {
  display: 'inline-block',
});

const flowLinksClass = cssClass(cssPrefix, 'flowLinks', flexColumnStyle);

const tooltipRootClass = cssClass(cssPrefix, 'tooltipRoot', {
  padding: TabStyles.Spacing.DefaultSpace
});

const tooltipItemClass = cssClass(cssPrefix, 'tooltipItem', textEllipsis, {
  paddingTop: TabStyles.Spacing.DefaultSpace,
  paddingBottom: TabStyles.Spacing.DefaultSpace
});

export type FlowLinksWithIconProps = {
  readonly flows: ReadonlyArray<FlowBaseInfo>;
  readonly hideIcon?: boolean;
  readonly siteUrls: SiteUrls;
};

export class FlowLinksWithIcon extends React.PureComponent<FlowLinksWithIconProps> {

  private getContent = (): Promise<JSX.Element> => {
    return Promise.resolve(
      <div className={tooltipRootClass}>
        <div className="tb-content-item-popover-title">
          {Messages.flowsPublishingCount({FLOW_COUNT_LOC: Formatters.formatCount(this.props.flows.length)})}
        </div>
        <div className={flowLinksClass}>
          {this.props.flows.map((flow, index) => {
            return <div key={index} className={tooltipItemClass}>{this.renderFlowLink(flow, false)}</div>;
          })}
        </div>
      </div>
    );
  };

  private renderFlowLink(flow: FlowBaseInfo, isDisplayedLink: boolean) {
    const url = this.props.siteUrls.flowUrl(flow.id);
    return isDisplayedLink ?
      <a className={displayedLinkClass} title={flow.name} href={url}>{flow.name}</a> :
      <a title={flow.name} href={url}>{flow.name}</a>;
  }

  private renderFlowLinks() {
    return (this.props.flows.length > 1 ?
      <CellWithCountAndToolTip count={'+' + (this.props.flows.length - 1)} getPopoverContent={this.getContent}>
        {this.renderFlowLink(this.props.flows[0], true)}
      </CellWithCountAndToolTip> :
      this.renderFlowLink(this.props.flows[0], true));
  }

  public render() {
    if (!this.props.flows || this.props.flows.length === 0) {
      return null;
    }

    const rootClass = this.props.hideIcon ? textClass : classes(textClass, flowIconClass);
    return (
      <span className={rootClass}>
        {this.renderFlowLinks()}
      </span>
    );
  }
}
